import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthenticationService } from 'services/authentication.service';
import { UserSessionService } from 'services/usersession.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private authService: AuthenticationService,
    private sessionService: UserSessionService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // if (!this.authService.isAuthenticated()) {
    //   this.router.navigate(['login'], { queryParams: { returnUrl: state.url } });
    //   return false;
    // }
    // return true;

   const pageTitle=state.root.children[0]['firstChild']['children'][0]['data']['title'];
   const pageTitle2=state.root['firstChild']['firstChild']['firstChild']['data']['title'];
   

    if (this.authService.isPageAccessAvailable(state.url,pageTitle)) {
      return true;
    }
    if (!this.authService.isPageAccessAvailable(state.url,pageTitle)) {
      this.router.navigate(['dashboard']);
      return false;
    }

    if (!this.authService.isAuthenticated()) {
      this.router.navigate(['login'], { queryParams: { returnUrl: state.url } });
      return false;
    }




  }

  hasRequiredPermission(permission) {
    for (let i = 0; i < permission.length; i++) {
      if (permission[i] === this.sessionService.roleId()) {
        return true;
      }
    }
    return false;
  }
}
